import { call, put } from 'redux-saga/effects';

import { getRegistrationsList } from '@api/registrations';
import { intl } from '@helpers/intl';
import { registrationsListModel } from '@models/Registrations';
import {
  registrationsListFetchSuccessAction,
  registrationsListFetchFailureAction,
} from '@store/registrations/registrationsList/registrationsList.actions';

export const registrationsListFetchSaga = function* ({ payload = {} }) {
  const { entityId, entityJurisdiction, status } = payload;

  try {
    const response = yield call(getRegistrationsList, entityId, entityJurisdiction, status, true);

    yield put(
      registrationsListFetchSuccessAction({
        data: registrationsListModel(entityId, entityJurisdiction, response),
        entityId,
      })
    );
  } catch (error) {
    const message =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      });

    yield put(registrationsListFetchFailureAction({ entityId, errorMessage: message }));
  }
};
